<div class="container home">
  <app-nav-menu (showPlaylistIframe)="showPlaylistIframe($event)"></app-nav-menu>
  <app-content [showPlaylistIframe]="showPlaylist"></app-content>
</div>
